/* eslint-disable no-undef */
import './style.scss';
import Cookies from 'js-cookie';

const parseDateTime = (value) => {
    if (!value) return null;

    if (value.includes('T')) {
        const d = new Date(value);
        if (!Number.isNaN(d.getTime())) return d;
    }

    const parts = value.split(' ');
    if (parts.length !== 2) return null;

    const dateParts = parts[0].split('-').map(v => Number(v));
    const timeParts = parts[1].split(':').map(v => Number(v));

    if (dateParts.length !== 3 || timeParts.length < 2) return null;

    const y = dateParts[0];
    const m = dateParts[1];
    const d = dateParts[2];
    const hh = timeParts[0] || 0;
    const mm = timeParts[1] || 0;
    const ss = timeParts[2] || 0;

    return new Date(y, m - 1, d, hh, mm, ss);
};

// end（終了時刻 Date）を受け取り、.lpcb-count-down-timer-v2 がある要素すべてを更新
const lpcbStartCountDownV2 = (end) => {
    const blocks = document.querySelectorAll('.lpcb-count-down-timer-v2');
    if (blocks.length === 0) return;

    // 複数ブロックがあっても、リダイレクトは1回だけ
    let hasRedirected = false;

    blocks.forEach(elem => {
        const dateElem = elem.querySelector('.js-lpcb-count-down-timer-v2__d');
        const hourElem = elem.querySelector('.js-lpcb-count-down-timer-v2__h');
        const minElem = elem.querySelector('.js-lpcb-count-down-timer-v2__m');
        const secElem = elem.querySelector('.js-lpcb-count-down-timer-v2__s');
        const msecElem = elem.querySelector('.js-lpcb-count-down-timer-v2__ms');

        // 終了日時の固定表示のときは数字の要素が無い。その場合も終了検知とリダイレクトは行う
        const hasDigits = !!(dateElem && hourElem && minElem && secElem);
        const isMsVisible = hasDigits && msecElem && window.getComputedStyle(msecElem).display !== 'none';
        const interval = isMsVisible ? 30 : 1000;

        let timerId = null;

        // 更新処理
        const update = () => {
            const now = new Date();

            // 終了時刻を過ぎたら停止＋ゼロ表示＋終了クラス付与＋（あれば）リダイレクト
            if (end.getTime() <= now.getTime()) {
                clearInterval(timerId);

                if (hasDigits) {
                    dateElem.innerHTML = '0';
                    hourElem.innerHTML = '00';
                    minElem.innerHTML = '00';
                    secElem.innerHTML = '00';
                    if (msecElem) msecElem.innerHTML = '00';
                }

                // 終了後表示に切り替えるためのクラス
                elem.classList.add('is-ended');

                // リダイレクトURLが設定されていれば一度だけ飛ばす
                const front = window.lpcbFrontJsValue;
                if (!hasRedirected && front && front.countdownSettings && front.countdownSettings.redirectUrl) {
                    hasRedirected = true;
                    window.location.href = front.countdownSettings.redirectUrl;
                }

                return;
            }

            // 固定表示は残り時間を書き換える要素が無いので、ここで終わり
            if (!hasDigits) return;

            // 残り時間
            const diff = end.getTime() - now.getTime();
            // 時間を分解
            const calcHour = Math.floor(diff / 1000 / 60 / 60);
            const calcDate = Math.floor(calcHour / 24);
            const calcMin = Math.floor(diff / 1000 / 60) % 60;
            const calcSec = Math.floor(diff / 1000) % 60;
            // 反映（0詰め）
            dateElem.innerHTML = String(calcDate);
            hourElem.innerHTML = String(calcHour % 24).padStart(2, '0');
            minElem.innerHTML = String(calcMin).padStart(2, '0');
            secElem.innerHTML = String(calcSec).padStart(2, '0');
            // ミリ秒は 0〜99（10ms単位）で2桁表示
            if (msecElem) {
                const calcMSec = String(Math.floor(diff / 10) % 100).padStart(2, '0');
                msecElem.innerHTML = calcMSec;
            }
        };

        // interval ごとに update を回す
        timerId = setInterval(update, interval);
        // 初回は即時表示更新（1秒待たない）
        update();
    });
};

// 設定（elapsed or specified）から end を決めて、lpcbStartCountDownV2(end) を呼ぶ関数
const lpcbCountDownTimerV2 = () => {
    const blocks = document.querySelectorAll('.lpcb-count-down-timer-v2');
    if (blocks.length === 0) return;

    // PHP側で埋め込んでいる想定のカスタムフィールド設定を取得
    const front = window.lpcbFrontJsValue;
    if (!front || !front.countdownSettings) return;

    const countDownSetting = front.countdownSettings;

    // elapsed：初回アクセス時刻を cookie に保存して、その + 指定時間が end
    if (countDownSetting.type === 'elapsed') {
        const postId = front.postId;
        const elapsedTime = Number(countDownSetting.elapsedTime || 0);
        const elapsedMin = Number(countDownSetting.elapsedMin || 0);
        const totalMilliseconds = (elapsedTime * 60 + elapsedMin) * 60 * 1000;
        const cookieKey = `_lpcb_access_datetime_v2_${postId}`;
        const saved = Cookies.get(cookieKey);
        let startMs;
        // 既存cookieが「数値」であればそれを採用
        if (saved && /^\d+$/.test(saved)) {
            startMs = Number(saved);
        } else {
            // 初回 or 旧形式cookie → 今この瞬間を保存して基準にする
            startMs = Date.now();
            Cookies.set(cookieKey, String(startMs), { expires: 31, path: '/' });
        }
        const end = new Date(startMs + totalMilliseconds);
        lpcbStartCountDownV2(end);

    // specified：メタで指定された終了日時を Date に変換して end にする
    } else {
        if (!countDownSetting.finishDatetime) return;
        const end = parseDateTime(countDownSetting.finishDatetime);
        if (!end) return;
        lpcbStartCountDownV2(end);
    }

    return;
};

// 読み込み直後に即実行（この script が読み込まれたタイミングで走る）
lpcbCountDownTimerV2();
